import React from "react";
import {
  FaCaretRight,
  FaEnvelope,
  FaFacebookSquare,
  FaInstagram,
  FaLinkedinIn,
  FaLocationArrow,
  FaPhone,
  FaRegEnvelope,
} from "react-icons/fa";
import footer_img from "../../assets/footer_image.png";
import oparajita from "../../assets/Oporajita.png";
import Needlelogo from "../../assets/red_logo2.png";
import { Link } from "react-router-dom";
import Button from "../UI/Button";
import BlueButton from "../UI/BlueButton";

export default function Footer() {
  let year = new Date().getFullYear();
  return (
    <div className="py-10 bg-secondary text-white relative">
      {/* <div className="max-w-7xl mx-auto pb-6 px-0 flex justify-center md:justify-start items-center">
        <img
          loading="lazy"
          src={Needlelogo}
          alt="Needle"
          className="w-[100px] h-auto"
        />
      </div> */}
      <div className="max-w-7xl mx-auto flex gap-6 flex-col md:flex-row justify-between items-start ">
        {/* <div className="max-w-7xl mx-auto grid grid-cols-4"> */}
        <div className="md:w-[400px]">
          {/* <h1 className="font-bold text-xl">Needle</h1> */}
          <div className="text-center md:text-left px-6 md:px-0">
            <div className="h-[80px]">
              <img
                src={oparajita}
                alt="Partner"
                className="w-[100px] h-auto "
              />
            </div>
            <div className="h-[50px]">
              <h2 className="font-bold text-xl pb-4">Oporajita- Collective Impact on Future of Work</h2>
            </div>
            <p className=" pb-2 text-justify mt-2">
              Needle Innovation Challenge is a part of Oporajita- Collective
              Impact on Future of Work in Bangladesh is a collaborative
              initiative among 9 Organizations to equip women garment workers
              in Bangladesh for a future defined by automation and
              digitalization. Initiated by H&amp;M Foundation, and supported by
              Sweden and The Asia Foundation, the initiative follows the
              Collective Impact approach, and aims to holistically address
              challenges to women’s future employment opportunities and
              livelihoods – and achieve transformative change for the industry
              and the people working within. The initiative covers multiple
              aspects within thematic areas that impact the lives of women
              garment workers, such as providing future-fit skill training,
              cultivating an enabling environment that supports their future
              aspiration and fostering collaboration in an RMG sector that is
              inclusive of their choices.
            </p>
          </div>
        </div>
        <div className="w-full md:w-1/4 flex flex-col gap-4 px-6 md:px-0">
          <div className="text-center md:text-left px-2 md:px-0">
            <div className="h-[80px]">
              <img
                loading="lazy"
                src={Needlelogo}
                alt="Needle"
                className="w-[100px] h-auto"
              />
            </div>
            <div className="h-[50px]">
              <h2 className="font-bold text-xl pb-4">
                Needle Innovation Challenge
              </h2>
            </div>
            <p className=" pb-2 ">
              Needle Innovation Challenge (NIC) is a multi-year startup development program focused on the RMG sector, initiated by Build Bangladesh, under the Oporajita Initiative. Currently in its Year 3, NIC identifies, nurtures, funds, and scales up viable businesses to enhance the competitiveness of Bangladesh’s RMG sector towards a circular economy.
            </p>
            <div className="flex itmes-center justify-center md:justify-start gap-2 pt-4">
              <a
                href="https://www.linkedin.com/company/needle-challenge/about/"
                target="_blank"
              >
                <FaLinkedinIn className="w-6 h-6" />
              </a>
              {/* <FaInstagram className="w-6 h-6" /> */}
              <a
                href="https://www.facebook.com/needleinnovationchallenge"
                target="_blank"
              >
                <FaFacebookSquare className="w-6 h-6" />
              </a>
            </div>
          </div>
        </div>
        <div className="w-full md:w-1/4 flex flex-col gap-4 px-6 md:px-0">
          <div className="h-[60px]"></div>
          <div className="h-[50px]">
            <h2 className="font-bold text-xl pb-4">Get Our Newsletter</h2>
          </div>
          <div className="flex items-center gap-4">
            <input
              type="EMAIL"
              name="fEmail"
              id="fEmail"
              placeholder="Your Email"
              className="w-full bg-transparent border border-white rounded-tl-[15px] rounded-br-[15px] px-4 py-2 focus:outline-none text-white placeholder:text-white"
            />
          </div>
          <div className="w-full">
            <button className="w-full md:max-w-fit px-8 py-2 text-secondary bg-white rounded-tl-xl rounded-br-xl cursor-pointer border-2 border-white  text-[18px] shadow-btn btn flex items-center border-none ">
              Submit
              <FaCaretRight className="inine btn_arrow" />
            </button>
          </div>

          <div className="flex items-center gap-4">
            <FaPhone />
            <p className="font-ruda">+88 01911-294278</p>
          </div>
          <div className="flex items-center gap-4">
            <FaEnvelope />
            <p className="font-ruda">info@buildbangladesh.org.bd</p>
          </div>
          <div className="flex items-center gap-4">
            <FaLocationArrow />
            <p className="font-ruda">
              Evergreen Plaza (first floor) 260/B, <br /> Tejgaon Industrial
              Area, Dhaka 1208
            </p>
          </div>
        </div>
      </div>
      <p className="text-center pt-8 md:pt-20">Copyright © {year} | Needle</p>
      <p className="text-center pt-2">
        Developed by{" "}
        <a href="https://ongshak.com/" target="_blank" className="">
          Ongshak
        </a>
      </p>
    </div>
  );
}
